/* Первый экран страницы кейсов: карточки коллажа по очереди показывают нарезку кадров.
   Каждый кадр держится holds[i] мс, затем текущий кадр гаснет (out), а следующий проявляется (in).
   Тайминги от дизайнера, замедленные на четверть (задержки) и на 200 мс (переходы) по просьбе заказчика. Анимация идёт только пока коллаж виден и вкладка активна. */

const CARDS = {
  'img-1': {
    holds: [5000, 5000, 5000, 5000, 5000],
    out: { ms: 800, ease: 'cubic-bezier(.42,0,.58,1)' },
    in: { ms: 700, ease: 'cubic-bezier(.42,0,1,1)' },
  },
  'img-2': {
    holds: [3100, 5100, 5100, 5100, 5800],
    out: { ms: 800, ease: 'cubic-bezier(0,0,.58,1)' },
    in: { ms: 700, ease: 'cubic-bezier(0,0,.58,1)' },
  },
  'img-3': {
    holds: [6900, 5300, 5300, 5300, 5300],
    out: { ms: 800, ease: 'cubic-bezier(0,0,.58,1)' },
    in: { ms: 700, ease: 'cubic-bezier(0,0,.58,1)' },
  },
};

const REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');

function runCard(card) {
  const config = CARDS[card.dataset.card];
  const frames = Array.from(card.querySelectorAll('.cases-page__hero__frame'));
  if (!config || frames.length < 2) return;

  let index = 0;
  let timer = 0;
  let running = false;

  const wait = (ms) =>
    new Promise((resolve) => {
      timer = window.setTimeout(resolve, ms);
    });

  const fade = (frame, to, step) => {
    frame.style.transition = `opacity ${step.ms}ms ${step.ease}`;
    frame.style.opacity = to;
    return wait(step.ms);
  };

  async function loop() {
    while (running) {
      await wait(config.holds[index % config.holds.length]);
      if (!running) break;
      const next = (index + 1) % frames.length;
      await fade(frames[index], '0', config.out);
      if (!running) break;
      await fade(frames[next], '1', config.in);
      index = next;
    }
  }

  const start = () => {
    if (running || REDUCED_MOTION.matches) return;
    running = true;
    loop();
  };

  const stop = () => {
    running = false;
    window.clearTimeout(timer);
    // Возвращаемся к чистому состоянию: виден только текущий кадр.
    frames.forEach((frame, i) => {
      frame.style.transition = '';
      frame.style.opacity = i === index ? '1' : '0';
    });
  };

  const observer = new IntersectionObserver(
    ([entry]) => (entry.isIntersecting && !document.hidden ? start() : stop()),
    { threshold: 0.2 },
  );
  observer.observe(card);

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) stop();
    else if (card.getBoundingClientRect().bottom > 0) start();
  });
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.cases-page__hero__collage__item[data-card]').forEach(runCard);
});
